export class ModbusSerialPort {
  baudrate: number = 0;
  parity: number = 0;
  databits: number = 5;
  stopbits: number = 0;
}